import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles/styles.module.scss';

const HeadText = ({ text, type }) => {
  return <div data-test-id="pro_text" className={`${styles.text} ${styles[type]}`}>{text}</div>;
};

HeadText.defaultProps = {
  text: 'Head Text',
  type: 'default'
};

HeadText.propTypes = {
  text: PropTypes.string,
  type: PropTypes.string
};

export default HeadText;
